export const GET_USER = "GET_USER";
export const GET_COINSELLER_UNIQUEID = "GET_COINSELLER_UNIQUEID";

export const CREATE_HOST_REQUEST = "CREATE_HOST_REQUEST";
export const HOST_DISABLE = "HOST_DISABLE";
export const REMOVE_HOST = "REMOVE_HOST";